import type { TourStep, VTourComponent } from '@/utils/tour';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useTourStore = defineStore('tour', () => {
    const steps = ref<TourStep[]>([]);
    const component = ref<VTourComponent | null>(null);
    const continueTour = ref(false);

    async function start() {
        component?.value?.resetTour(true);
        component?.value?.startTour();

        continueTour.value = false;
    }

    return { steps, component, continueTour, start };
});
